<div fxFlex="0 0 100%" fxLayout="row wrap" class="section-user-select sticky-title-wrapper">
    <app-sticky-header
        class="sticky-header"
        [title]="data.resource.title"
        [context]="'Enrollment'"
        [contextIcon]="'app_registration'"
        (onSubmit)="submit()"
        (onCancel)="bottomSheetRef.dismiss()"
    ></app-sticky-header>
    <div class="enrollment-sheet-content">
        <div class="added-content" fxLayout="column" fxLayoutAlign="center end">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <span i18n>Selected Approval status:</span>
                <mat-form-field class="templates-select" fxFlex="0 0 100px">
                    <mat-select [formControl]="approvalStatus">
                        <mat-option value="pending"> Pending </mat-option>
                        <mat-option value="approved"> Approved </mat-option>
                        <mat-option value="waiting"> Waiting </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="remaining-seats" *ngIf="remainingSeats > 0">
                <span i18n>Remaining seats:</span>
                <span>{{ remainingSeats - selectionCount }}</span>
            </div>
        </div>
        <ng-container *ngIf="customer$ | async; let customer">
            <app-users-select-add-enrollment
                #usersSelect
                class="m-1"
                defaultSorting="disabled"
                [customer_id]="data.customer_id"
                [referenceFilter]="data.occId ? 'enrolledOccasionDate' : 'enrolledResource'"
                [accessForm]="assignForm"
                [filtersToBeApplied]="filtersToBeApplied"
            ></app-users-select-add-enrollment>
        </ng-container>
    </div>
</div>
